import { render, staticRenderFns } from "./defectType.vue?vue&type=template&id=6a194649&scoped=true&"
import script from "./defectType.vue?vue&type=script&lang=js&"
export * from "./defectType.vue?vue&type=script&lang=js&"
import style0 from "./defectType.vue?vue&type=style&index=0&id=6a194649&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a194649",
  null
  
)

export default component.exports